import { MultiStepFormState } from '@delmonicos/shared-design-system-react/src/contexts/multi-step-form-item';
import {
  MultiStepFormProvider,
  SubmitHandlerWithDirtyFields,
} from '@delmonicos/shared-design-system-react/src/contexts/multi-step-form.provider';
import { GetEmspUsersPaginatedModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/emsp-bo/models/inputs/emsp-users/get-emsp-users-paginated.model';
import { SubmitErrorHandler } from 'react-hook-form';

import { useFilterEmspBoEmspUserListContext } from '../../emsp-bo-emsp-user.context';
import { EmspUserListFilterFormStep1Controller } from './emsp-user-list-filter-form-step-1/emsp-user-list-filter-form-step-1.controller';

export interface EmspUserListFilterFormControllerProps {
  onSubmit: SubmitHandlerWithDirtyFields<GetEmspUsersPaginatedModel>;
  onError: SubmitErrorHandler<GetEmspUsersPaginatedModel>;
  onCancel: () => void;
  state: MultiStepFormState;
}

export const EmspUserListFilterFormController = (
  props: EmspUserListFilterFormControllerProps,
): React.JSX.Element => {
  const { onError, onSubmit, onCancel, state } = props;
  const data = useFilterEmspBoEmspUserListContext();

  return (
    <MultiStepFormProvider<GetEmspUsersPaginatedModel>
      useFormProps={{
        mode: 'all',
        defaultValues: data,
      }}
      submitErrorHandler={onError}
      submitHandler={onSubmit}
      onCancel={onCancel}
      state={state}
      items={[
        {
          fields: ['billingFrequency'],
          component: <EmspUserListFilterFormStep1Controller />,
        },
      ]}
    />
  );
};
